import { PENDING, FULFILLED, REJECTED } from "redux-promise-middleware";
import {
  FETCH_ORDER_STATUSES,
  FETCH_ORDER_STATUS,
} from "../actions/orderStatus";

const SINGLE_DATA_INITIAL_STATE = {
  data: {},
  error: null,
  loading: false,
};
const MULTI_DATA_INITIAL_STATE = {
  data: [],
  error: null,
  loading: false,
};

export function orderStatuses(
  state = MULTI_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_ORDER_STATUSES}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_ORDER_STATUSES}_${FULFILLED}`:
      return Object.assign({}, state, payload, {
        loading: false,
        error: null,
      });
    case `${FETCH_ORDER_STATUSES}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}

export function orderStatus(
  state = SINGLE_DATA_INITIAL_STATE,
  { type, payload }
) {
  switch (type) {
    case `${FETCH_ORDER_STATUS}_${PENDING}`:
      return Object.assign({}, state, { loading: true, error: null });
    case `${FETCH_ORDER_STATUS}_${FULFILLED}`:
      return Object.assign(
        {},
        state,
        { data: payload.data },
        { loading: false, error: null }
      );
    case `${FETCH_ORDER_STATUS}_${REJECTED}`:
      return Object.assign({}, state, {
        loading: false,
        error: payload,
      });
    default:
      return state;
  }
}
